import { ResponsiveUtilities } from './utils';

const setEqualHeight = (targetDevices, elem) => {
  let maxHeight = 0;
  ResponsiveUtilities.onDeviceType(targetDevices, function () {
    elem.each(function () {
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    elem.height(maxHeight);
  });
};

export default { setEqualHeight };
